import { reduxForm, change } from 'redux-form'
import { Autosuggest } from '../../components/common'
import { getAvailableOrgs } from '../../actions/typeaheads'
import {
  ORG_SEARCH_FORM_NAME,
  ORG_SEARCH_FIELD_NAME,
  ORG_SEARCH_FIELD_ID,
  ORG_SEARCH_FIELD_AICODE,
} from '../../constants/OrdersConstants'

const checkSchoolSelected = (val, allValues) =>
  Boolean(allValues[ORG_SEARCH_FIELD_ID])
    ? undefined
    : 'Error: You must select a school from the dropdown.'

const OrdersOrgSearchForm = ({ change }) => (
  <form onSubmit={e => e.preventDefault()}>
    <label htmlFor={ORG_SEARCH_FIELD_NAME}>
      Enter school&#39;s name or AI code to find its orders
    </label>
    <Autosuggest
      formGroupStyles={{ marginBottom: 0 }}
      placeholder="Start typing to search for organization"
      isRequired={true}
      name={ORG_SEARCH_FIELD_NAME}
      fetchSuggestions={val => getAvailableOrgs(val, { searchWithinAP: true })}
      renderSuggestion={s => (
        <div>
          <div>{s.orgName}</div>
          <div>{s.address}</div>
        </div>
      )}
      onChangeAction={() => change(ORG_SEARCH_FIELD_ID, null)}
      selectSuggestion={val => {
        change(ORG_SEARCH_FIELD_NAME, val.orgName)
        change(ORG_SEARCH_FIELD_ID, val.orgId)
        change(ORG_SEARCH_FIELD_AICODE, val.aiList[0]?.ai_code)
      }}
      validate={[checkSchoolSelected]}
    />
  </form>
)

export default connect(
  null,
  { change }
)(
  reduxForm({
    form: ORG_SEARCH_FORM_NAME,
    initialValues: {
      [ORG_SEARCH_FIELD_NAME]: null,
      [ORG_SEARCH_FIELD_ID]: null,
      [ORG_SEARCH_FIELD_AICODE]: null,
    },
  })(OrdersOrgSearchForm)
)
